module.exports = __webpack_public_path__ + "static/img/0546_3.a73ad8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0546_3.jpg
// module id = LFFq
// module chunks = 1